import { keyframes } from '@emotion/core';

const circleAnimation = keyframes({
  ' 0%': {
    transform: 'rotateZ(0deg)'
  },
  '66%': {
    transform: 'rotateZ(220deg)'
  },
  '100%': {
    transform: 'rotateZ(360deg)'
  }
});

const sTailChaserAnimation = keyframes({
  '0%': {
    strokeDashoffset: 15,
    transform: 'rotateZ(0deg)'
  },
  '50%': {
    strokeDashoffset: 0,
    transform: 'rotateZ(45deg)'
  },
  '100%': {
    strokeDashoffset: 15,
    transform: 'rotateZ(360deg)'
  }
});

const mTailChaserAnimation = keyframes({
  '0%': {
    strokeDashoffset: 26,
    transform: 'rotateZ(0deg)'
  },
  '50%': {
    strokeDashoffset: 6,
    transform: 'rotateZ(45deg)'
  },
  '100%': {
    strokeDashoffset: 26,
    transform: 'rotateZ(360deg)'
  }
});

const lTailChaserAnimation = keyframes({
  '0%': {
    strokeDashoffset: 40,
    transform: 'rotateZ(0deg)'
  },
  '50%': {
    strokeDashoffset: 3,
    transform: 'rotateZ(45deg)'
  },
  '100%': {
    strokeDashoffset: 40,
    transform: 'rotateZ(360deg)'
  }
});

const xlTailChaserAnimation = keyframes({
  '0%': {
    strokeDashoffset: 48,
    transform: 'rotateZ(0deg)'
  },
  '50%': {
    strokeDashoffset: 2,
    transform: 'rotateZ(45deg)'
  },
  '100%': {
    strokeDashoffset: 48,
    transform: 'rotateZ(360deg)'
  }
});

export const getStyle = theme => {
  // const accentColors = {
  //   gradientColor1: theme.backgroundColor.accent.fill.active,
  //   gradientColor2: theme.backgroundColor.accent.fill.active,
  //   gradientColor3: theme.backgroundColor.accent.fill.active,
  //   rail: theme.backgroundColor.interactive.base
  // };
  // const dangerColors = {
  //   gradientColor1: theme.backgroundColor.danger.fill.active,
  //   gradientColor2: theme.backgroundColor.danger.fill.active,
  //   gradientColor3: theme.backgroundColor.danger.fill.active,
  //   rail: theme.backgroundColor.interactive.base
  // };
  // const primaryColors = {
  //   gradientColor1: theme.backgroundColor.interactive.fill.active,
  //   gradientColor2: theme.backgroundColor.interactive.fill.active,
  //   gradientColor3: theme.backgroundColor.interactive.fill.active,
  //   rail: theme.backgroundColor.interactive.base
  // };
  const defaultColors = {
    gradientColor1: theme.backgroundColor.tertiary.fill.surface,
    gradientColor2: theme.backgroundColor.brand.fill.focus,
    gradientColor3: theme.backgroundColor.accent.fill.surface,
    rail: theme.backgroundColor.active
  };
  // const successColors = {
  //   gradientColor1: theme.backgroundColor.success.fill.active,
  //   gradientColor2: theme.backgroundColor.success.fill.active,
  //   gradientColor3: theme.backgroundColor.success.fill.active,
  //   rail: theme.backgroundColor.interactive.base
  // };
  // const tertiaryColors = {
  //   gradientColor1: theme.backgroundColor.tertiary.fill.active,
  //   gradientColor2: theme.backgroundColor.tertiary.fill.active,
  //   gradientColor3: theme.backgroundColor.tertiary.fill.active,
  //   rail: theme.backgroundColor.interactive.base
  // };
  // const warningColors = {
  //   gradientColor1: theme.backgroundColor.warning.fill.surface,
  //   gradientColor2: theme.backgroundColor.warning.fill.surface,
  //   gradientColor3: theme.backgroundColor.warning.fill.surface,
  //   rail: theme.backgroundColor.interactive.base
  // };

  return {
    // accentColors,
    // dangerColors,
    // primaryColors,
    defaultColors,
    // successColors,
    // tertiaryColors,
    // warningColors,
    outerContainer: {
      base: {
        fontFamily: theme.font.base.family,
        fontSize: theme.font.base.size.h4,
        fontWeight: theme.font.base.weight.regular,
        position: 'relative',
        overflow: 'visible',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        transformOrigin: '50% 50%',
        flexGrow: 0,
        flexShrink: 0
      },
      big: {},
      inline: {
        flexDirection: 'row'
      }
    },

    circle: {
      base: {
        strokeDasharray: 45,
        animation: `${circleAnimation} 3.773s linear infinite`,
        transformOrigin: '50% 50%',
        overflow: 'visible',
        stroke: theme.backgroundColor.active,
        strokeLinecap: 'round',
        strokeWidth: '2px',
        marginBottom: 2,
        fill: 'transparent'
      },
      m: {
        width: theme.icon.size.m,
        height: theme.icon.size.m,
        strokeDasharray: 400
      },
      l: {
        width: theme.icon.size.l,
        height: theme.icon.size.l,
        strokeDasharray: 400
      },
      xl: {
        width: theme.icon.size.xl,
        height: theme.icon.size.xl,
        strokeDasharray: 400
      },
      s: { width: theme.icon.size.s, height: theme.icon.size.s },

      slow: {
        animation: `${circleAnimation} 37.73s linear infinite`
      }
    },
    tailChaser: {
      base: {
        transformOrigin: '50% 50%',
        strokeWidth: '2px',
        fill: 'transparent',
        strokeLinecap: 'round'
      },
      s: {
        animation: `${sTailChaserAnimation}  2.45s linear infinite`,
        strokeDasharray: 27
      },
      m: {
        animation: `${mTailChaserAnimation}  2.45s linear infinite`,
        strokeDasharray: 33
      },
      l: {
        strokeDasharray: 50,
        animation: `${lTailChaserAnimation}  2.45s linear infinite`
      },
      xl: {
        strokeDasharray: 66,
        animation: `${xlTailChaserAnimation}  2.45s linear infinite`
      }
    }
  };
};
